<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import ExpandingSection from "@/components/shared/section/ExpandingSection.vue";
import ProgramLeaderItem from "@/components/program-manager/sessions/components/ProgramLeaders/ProgramLeaderItem.vue";
import PlusIcon from "@/components/shared/icons/PlusIcon.vue";
import { useVModel } from "@vueuse/core";
import { useGetProfiles } from "@/components/program-manager/sessions/composable";
import { vuelidateCollectionHelper } from "@/components/program-manager/sessions/components/CreateEditProgramSessions/utils";

const emits = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {},
  },
  vuelidateInstance: {
    type: Object,
    default: () => {},
  },
});

const programSession = useVModel(props, "modelValue", emits);

const profile_ids = programSession.value?.session_profiles?.map(
  ({ profile_id }) => profile_id
);

const {
  execute: fetchSessionProfiles,
  state: sessionProfiles,
  isLoading: profileLoading,
} = useGetProfiles(
  { immediate: false, throwError: false, resetOnExecute: true },
  {
    limit: 10,
    skip: 0,
    extraParams: { profile_ids },
  }
);

const addProgramLeader = () => {
  programSession.value?.session_profiles?.push({
    session_id: programSession.value.id,
    legal_first_name: "",
    preferred_first_name: "",
    profile_id: "",
    role: "",
    last_name: "",
  });
};

if (profile_ids?.length) {
  fetchSessionProfiles(0, {
    cancel: true,
  }).then(() => {
    const fetchedProfilesMap = sessionProfiles.value.items.reduce(
      (acc, profile) => ({ ...acc, [profile.id]: profile }),
      {}
    );
    programSession.value.session_profiles =
      programSession.value?.session_profiles?.map((currentSessionProfile) => {
        const additionalProfileInfo = fetchedProfilesMap[
          currentSessionProfile?.profile_id
        ] || { legal_first_name: "", preferred_first_name: "", last_name: "" };

        return {
          ...currentSessionProfile,
          legal_first_name: additionalProfileInfo?.legal_first_name,
          preferred_first_name: additionalProfileInfo?.preferred_first_name,
          last_name: additionalProfileInfo?.last_name,
        };
      }) || [];
  });
}

const deleteProgramLeader = (index) => {
  programSession.value?.session_profiles?.splice(index, 1);
};
</script>

<template>
  <ExpandingSection field-label="Program Leaders" class="col-span-2">
    <template #content>
      <div class="grid grid-cols-2 gap-x-24 gap-y-4">
        <ProgramLeaderItem
          v-for="(_, index) in programSession.session_profiles"
          :key="index"
          v-model="programSession.session_profiles[index]"
          :parent-loading="profileLoading"
          :vuelidate-instance="
            vuelidateCollectionHelper(vuelidateInstance, index, 'profile_id')
          "
          @delete-item="deleteProgramLeader(index)"
        />
      </div>
      <div
        class="mt-2 col-span-2 flex items-center cursor-pointer"
        @click="addProgramLeader"
      >
        <PlusIcon class="text-cyan-100 inline h-10 w-10 mr-2" />
        <label class="common-label-text inline">Add another</label>
      </div>
    </template>
  </ExpandingSection>
</template>
